import * as React from "react";
import { Checkbox } from "@mui/material";
import CardItemTooltip from "../../../shared/CardItemTooltip";

const CheckboxButton = ({
	handleToggle,
	labelId,
	checked,
	textWrapColorClass,
	buttonText,
	className,
	size,
	disableRipple,
	disabled,
	sx,
	item,
	colorBox = null,
	isSpacialItem = false,
	allowSpecialItemSelection = false, // Enable selection for special items (e.g., average items) when true
}) => {
	// Show checkbox if: not a special item OR special item selection is allowed
	const showCheckbox = !isSpacialItem || allowSpecialItemSelection;
	
	return (
		<>
			{showCheckbox && (
				<div style={{ 
					cursor: (disabled || item?.isReadOnly) ? 'not-allowed' : 'default',
					display: 'inline-flex',
					alignItems: 'center'
				}}>
					<Checkbox
						className={className}
						edge={"start"}
						disabled={disabled || item?.isReadOnly}
						disableRipple					
						sx={{ 
							mr: 0.1, 
							...(sx && sx),
							...(disabled || item?.isReadOnly) && {
								'&.MuiCheckbox-root.Mui-disabled': {
									cursor: 'not-allowed !important',
									pointerEvents: 'auto !important'
								},
								'&.MuiCheckbox-root.Mui-disabled .MuiSvgIcon-root': {
									cursor: 'not-allowed !important'
								}
							}
						}}
						onChange={(e) => typeof handleToggle === 'function' && handleToggle(e)}
						checked={checked}
						inputProps={{ "aria-labelledby": labelId }}
						{...(size && { size: size })}
						{...(disableRipple && { disableRipple: disableRipple })}
					/>
				</div>
			)}
			<CardItemTooltip item={item}>
				<div className={`df aic ${textWrapColorClass}`} id={labelId}>
					{colorBox && <span>{colorBox}</span>}
					<p className={`ffmar fs12 fw700`}>{buttonText}</p>
				</div>
			</CardItemTooltip>
		</>
	);
};

export default CheckboxButton;
